import {
  GET_CHAPTER_NUMBER,
  GET_COUNTRY_BY_STATUS,
  GET_DATA_BY_HTSCODE,
  GET_DUTIES_RATE_BY_HTS_TEST,
  GET_HTS_BY_CHAPTER,
  GET_JSON_BY_HISCODE,
  GET_PRODUCT_BY_HISCODE,
  HIS_CODE_DETAIL,
  LOGIN,
  SEARCH_HIS_CODE,
  SIGNUP,
  UPLOAD_HTS_JSON,
  FORGOT_PASSWORD,
  GET_PRODUCT_JSON_BY_COUNTRY,
  GET_PRODUCT_TARIFF_DATA,
  GET_SEARCH_PRODUCT,
} from "./endpoints";
import { auth, noAuth } from "./instance";

export async function login(data) {
  try {
    const params = new URLSearchParams();
    params.append("username", data.username);
    params.append("password", data.password);

    const response = await noAuth().post(LOGIN, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function signup(data) {
  try {
    const response = await noAuth().post(SIGNUP, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function forgot_password(email) {
  try {
    const res = await noAuth().post(`/forgot_password?email=${email}`);
    return { data: res.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function search_his_codes(params) {
  try {
    const response = await auth().get(SEARCH_HIS_CODE, { params });
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function his_code_detail(id) {
  try {
    const response = await auth().get(`${HIS_CODE_DETAIL}/${id}`);

    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_duties_rate_by_hts_test(params) {
  try {
    const response = await auth().get(GET_DUTIES_RATE_BY_HTS_TEST, { params });
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_json_by_hiscode(his_code, id) {
  try {
    const response = await auth().get(`${GET_JSON_BY_HISCODE}/${his_code}`, {
      params: { id: id },
    });
    // const response = await auth().get(`${GET_JSON_BY_HISCODE}/7019`);
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_data_by_htscode(params, countrycode) {
  try {
    const response = await auth().get(GET_DATA_BY_HTSCODE, {
      params: { hts_number: params, countrycode: countrycode },
    });
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_country_by_status(params) {
  try {
    const response = await auth().get(GET_COUNTRY_BY_STATUS, { params });
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_hts_by_chapter(id) {
  try {
    const response = await auth().get(`${GET_HTS_BY_CHAPTER}/${id}`);
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function upload_hts_json(data, id) {
  try {
    const response = await auth().post(UPLOAD_HTS_JSON, data, {
      params: { chapter_number: id },
    });
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_chapter_numbers() {
  try {
    const response = await auth().get(GET_CHAPTER_NUMBER);
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_product_by_hiscode(id) {
  try {
    const response = await auth().get(`${GET_PRODUCT_BY_HISCODE}/${id}`);
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_product_json_by_country(id, country_code) {
  try {
    const response = await auth().get(
      `${GET_PRODUCT_JSON_BY_COUNTRY}?code_prefix=${id}&country_code=${country_code}`
    );

    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}
export async function search_product(country_code, product) {
  try {
    const response = await auth().get(GET_SEARCH_PRODUCT, {
      params: {
        country_code: country_code,
        search: product,
        search_type: "both",
      },
    });
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}

export async function get_product_tariff_data(hsCode, countryCode) {
  try {
    const response = await auth().get(
      `${GET_PRODUCT_TARIFF_DATA}?hs_code=${hsCode}&country_code=${countryCode}`
    );
    return { data: response.data, error: null };
  } catch (error) {
    return { error, data: null };
  }
}
